// extracted by mini-css-extract-plugin
export default {"container":"B_-z","tab":"C_-z","selected":"D_-z"};